import React from 'react';
import {ManageOrderDetailProduct} from './sub-view/manage-order';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessManageOrderDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active='my-business-orders'>
        <h1 className="user-header">Chi tiết đơn hàng</h1>
        <ManageOrderDetailProduct params={this.props.params}/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessManageOrderDetailContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessManageOrderDetailContainer.jsx